import React from 'react';
import styled from 'styled-components';

import { AppState } from '../../store';
import { UserInterface } from '../../store/base/types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { Card, DynamicForm, Spin } from '../elements';
import { updateUserProfile } from '../../store/base/functions';

type UserProfileComponentProps = {
    className?: string,
    match: any,
    user: UserInterface,
    onUserUpdate: Function,
    isLoading: boolean
}

const UserProfileComponent = (props: UserProfileComponentProps) => {
    const handleSubmit = (data : UserInterface) => {
        delete data['phone'];
        data = Object.assign({}, data, {
            avatar_id : null,
            signature_id: null
        })
        props.onUserUpdate(data, props.user ? props.user.id : null);
    }

    const fields = [
        {
            id: "phone",
            htmltype : "phone",
            label : "تلفن همراه",
            defaultValue: props.user.phone,
            disabled: true
        },
        {
            id : "first_name",
            htmltype : "text",
            label : "نام",
            defaultValue: props.user.first_name
        },
        {
            id : "last_name",
            htmltype: "text",
            label : "نام خانوادگی",
            defaultValue: props.user.last_name
        },
        {
            id: "email",
            htmltype: "email",
            label : "ایمیل",
            defaultValue: props.user.email
        }
    ]

    return (
      <div className={props.className} style={{marginLeft:20}}>
          {props.user &&
            <Card
              title={"ویرایش پروفایل کاربری"}
            >
                <Spin active={props.isLoading}>
                    <div style={{padding:'20px'}}>
                        <DynamicForm fields={fields} onSubmit={handleSubmit}/>
                    </div>
                </Spin>
            </Card>
          }
        </div>

    )
}

const UserProfile = styled(UserProfileComponent)`

`

const mapStateToProps = (state: AppState,ownProps: any) => ({
  user: state.base.user,
  isLoading: state.base.isLoading
});

const mapDispatchToProps = (dispatch:any) => {
    return {
        onUserUpdate: (data :UserInterface, id :number) => dispatch(updateUserProfile(data, id))
    };
  };
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserProfile));